import type { ReactNode } from 'react'

import { useState } from 'react'

import styles from './card.module.css'
import { CardContext } from './context'
interface Props {
  children: ReactNode
  expandable?: boolean
}

export function Card ({ children, expandable }: Props): JSX.Element {
  const [ cardOpen, setCardOpen ] = useState(true)

  return (
    <CardContext.Provider
      value={{
        showExpandableHandler: !!expandable,
        open: cardOpen,
        setOpen: value => setCardOpen(value)
      }}
    >
      <div className={styles.card}>
        {children}
      </div>
    </CardContext.Provider>
  )
}
